import React from 'react';
import PropTypes from 'prop-types';
import AirportFacilityDetails from 'common/airport/AirportFacilityDetails';

const SpotDetailsAirportHero = ({
    facility
}) => {
    return (
        <div className="SpotDetailsAirportHero">
            <div className="container">
                <AirportFacilityDetails
                    facility={facility}
                />
            </div>
        </div>
    );
};

SpotDetailsAirportHero.propTypes = {
    facility: PropTypes.object.isRequired
};

export default SpotDetailsAirportHero;
